import React, {Component, Fragment} from "react";
import * as R from "ramda";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import Api from "../../../../Services/Api";
import {flattenFormGroupObject, getValueFromDDL, mapToDDL} from "../../../common/mapper";
import SimpleDate from "../../../../modules/SimpleDate";
import M from "moment";
import FlexView from "react-flexview";
import {defaultTableChange} from "../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import {initialData, tableColumns} from "../config";
import {getUserAccess} from "../../../../Services/Utils";
import {v4 as uuidv4} from "uuid";
import SimplePrintTable from "../../../../modules/popup/SimplePrintTable";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import MasterBBNUploadFile from "./MasterBBNUploadFile";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import {ACTIVITY_TYPE} from "../../../common/Constants";
import {validate} from "../util";

class MasterBBNModifying extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            warningModalVisible: false,
            printModalVisible: false,
            uploadFileModalVisible: false,
            deleteModalVisible: false,
            deleteRawModalVisible: false,
            deleteMessage: null,
            deleteRawMessage: null,
            selectedDataDetailIndex: null,
            search: {
                kodeVariant: null,
            },
            tableColumns: [],
            dataTable: [],
            dataRollBackTable: [],
            dataSamsat: [],
            dataVariant: [],
            dataVariantRollBack: [],
            dataKodeUnitPabrik: [],
            dataKodeUnitPabrikRollBack: [],
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchDataSamsat();
        await this.fetchDataVariant();
        if (R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE)) {
            await this.fetchDataDetail();
        }
        this.setState((prevState) => ({
            ...prevState,
            tableColumns: [
                ...tableColumns.detailPage(
                    getUserAccess(this.props.menuAccess, this.props.selectedCabang?.value),
                    this.state.dataVariant,
                    this.props.deleteAction,
                    this.handleChangeVariant,
                    this.handleValueChange,
                    this.handleDeleteRawModalVisibility,
                    this.props.activityType,
                    this.handleRefreshDataVariant,
                    this.state.dataKodeUnitPabrik,
                    this.handleChangeKodeUnitPabrik,
                    this.handleRefreshKodeUnitPabrik
                )
            ]
        }));
        this.handleTriggerLoading();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.dataTable !== this.state.dataTable) {
            this.handleRefreshDataVariant();
        }
    }

    handleRefreshDataVariant = (item) => {
        let dataVariant = this.state.dataVariantRollBack.filter(
          (item) =>
            !this.state.dataTable
          .map((data) => data.kodeVariant)
          .includes(item.value)
        );

        if(item){
            const tableData = this.state.dataTable[item.rowIndex]
            if(tableData?.kodeUnitPabrik){
                dataVariant = dataVariant.filter(item => item.kodeUnitPabrik === tableData.kodeUnitPabrik)
            }
        }


        this.setState((prevState) => ({
            ...prevState,
            dataVariant,
            tableColumns: [
                ...tableColumns.detailPage(
                    getUserAccess(this.props.menuAccess, this.props.selectedCabang?.value),
                    dataVariant,
                    this.props.deleteAction,
                    this.handleChangeVariant,
                    this.handleValueChange,
                    this.handleDeleteRawModalVisibility,
                    this.props.activityType,
                    this.handleRefreshDataVariant,
                    this.state.dataKodeUnitPabrik,
                    this.handleChangeKodeUnitPabrik,
                    this.handleRefreshKodeUnitPabrik
                )
            ]
        }));
    }

    handleRefreshKodeUnitPabrik = (item) => {
        let dataKodeUnitPabrik = this.state.dataKodeUnitPabrik


        if (item) {
          const tableData = this.state.dataTable[item.rowIndex];
          
          if (!tableData.kodeVariant) {
            dataKodeUnitPabrik = this.state.dataKodeUnitPabrikRollBack.filter(
              (item) =>
                !this.state.dataTable
                  .map((data) => data.kodeUnitPabrik)
                  .includes(item.value)
            );
          }
        }



        this.setState((prevState) => ({
            ...prevState,
            dataKodeUnitPabrik,
            tableColumns: [
                ...tableColumns.detailPage(
                    getUserAccess(this.props.menuAccess, this.props.selectedCabang?.value),
                    this.state.dataVariant,
                    this.props.deleteAction,
                    this.handleChangeVariant,
                    this.handleValueChange,
                    this.handleDeleteRawModalVisibility,
                    this.props.activityType,
                    this.handleRefreshDataVariant,
                    dataKodeUnitPabrik,
                    this.handleChangeKodeUnitPabrik,
                    this.handleRefreshKodeUnitPabrik
                )
            ]
        }));
    }

    handleWarningModalVisibility = (text) => {
        this.setState((prevState) => ({
            ...prevState,
            warningMessage: text,
            warningModalVisible: !prevState.warningModalVisible,
        }))
    }

    handleUploadFileModalVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            uploadFileModalVisible: !prevState.uploadFileModalVisible,
        }))
    }

    handleDeleteModalVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            deleteModalVisible: !prevState.deleteModalVisible,
            deleteMessage: "Penghapusan data Master Tabel BBN akan menghapus semua data Tabel BBN. Apakah anda yakin?",
        }))
    }

    handleDeleteRawModalVisibility = (index) => {
        this.setState((prevState) => ({
            ...prevState,
            deleteRawModalVisible: !prevState.deleteRawModalVisible,
            deleteRawMessage: "Apakah anda yakin ingin menghapus data Harga Tabel BBN?",
            selectedDataDetailIndex: !R.isNil(index) ? index : null,
        }))
    }

    handleAddRow = () => {
        const newData = {
            id: uuidv4(),
            ...initialData.detail,
        }

        this.setState((prevState) => ({
            ...prevState,
            dataTable: [...prevState.dataTable, newData],
            dataRollBackTable: [...prevState.dataRollBackTable, newData],
        }));
    }

    handleDeleteRow = (index) => {
        this.setState((prevState) => ({
            ...prevState,
            deleteRawModalVisible: !prevState.deleteRawModalVisible,
            dataTable: [...prevState.dataTable.filter((_, idx) => idx !== index)],
            dataRollBackTable: [...prevState.dataRollBackTable.filter((_, idx) => idx !== index)],
        }))
    }

    handleValueChange = (index, name, value) => {
        this.setState((prevValue) => {
            const newState = [...prevValue.dataTable];
            newState[index] = {
                ...newState[index],
                [name]: value
            };

            return {
                ...prevValue,
                dataTable: newState,
                dataRollBackTable: newState
            };
        });
    };

    handleChangeVariant = (index, name, value) => {
        if (!R.isEmpty(this.state.dataVariant)) {
            let variant = this.state.dataVariantRollBack.find(item => item.value === value.value);
            const kodeUnitPabrik = this.state.dataKodeUnitPabrik.filter(item=>item.value === value?.kodeUnitPabrik)
            
            this.setState((prevState) => {
                const newState = [...prevState.dataTable];
                newState[index] = {
                    ...newState[index],
                    [name]: value,
                    namaVariant: variant?.name,
                    kodeUnitPabrik: variant?.kodeUnitPabrik
                };

                return {
                    ...prevState,
                    dataTable: newState,
                    dataRollBackTable: newState,
                    dataKodeUnitPabrik: kodeUnitPabrik
                };
            });
        }
    }
    
    handleChangeKodeUnitPabrik = (index, name, value) => {
        if (!R.isEmpty(this.state.dataVariant)) {
            const variant = value ? this.state.dataVariantRollBack.filter(item => item.kodeUnitPabrik === value?.value) : this.state.dataVariantRollBack;
            this.setState((prevState) => {
                const newState = [...prevState.dataTable];
                newState[index] = {
                    ...newState[index],
                    [name]: value?.value,
                    kodeVariant: variant.length === 1 ? {
                        label: `${variant[0]?.value} - ${variant[0]?.kodeUnitPabrik} - ${variant[0]?.name}`,
                        value: variant[0]?.value
                    } : null,
                    namaVariant: variant.length === 1 ? variant[0]?.name : null
                };

                return {
                    ...prevState,
                    dataTable: newState,
                    dataRollBackTable: newState
                };
            });
        }
    }

    handleSubmit = () => {
        if (!this.props.customValidate(validate(this.props.controls, this.state.dataRollBackTable))) {
            this.handleWarningModalVisibility("Ada field data yang perlu diisi atau tidak sesuai kriteria isian.");
            return;
        }

        const formGroup = flattenFormGroupObject(this.props.controls);
        let kodeSamsat = formGroup["kodeSamsat"]?.map(item => item.value) || [];
        if (kodeSamsat.includes("ALL")) {
            kodeSamsat = ["ALL"];
        }

        const requestBody = {
            ...formGroup,
            id: this.props.selectedData?.id,
            kodeSamsat: kodeSamsat,
            variants: this.state.dataRollBackTable.map(item => {
                return {
                    bbnPrice: item.bbnPrice,
                    differenceIncomeBbn: item.differenceIncomeBbn,
                    kodeVariant: item.kodeVariant?.value
                }
            }),
        };

        this.props.onSubmit(requestBody);
    };

    handleValueChangeSearch = (name, value) => {
        this.setState((prevState) => ({
            ...prevState,
            search: {
                ...prevState.search,
                [name]: value,
            },
        }));
    };

    handleResetSearch = () => {
        this.setState((prevState) => ({
            ...prevState,
            dataTable: prevState.dataRollBackTable,
            search: {
                kodeVariant: null
            },
        }));
    }

    handleSubmitSearch = () => {
        this.setState((prevState) => ({
            ...prevState,
            dataTable: prevState.dataRollBackTable.filter((item) => {
                return R.includes(prevState.search.kodeVariant, item.kodeVariant)
            }),
        }))
    }

    handleChangeFile = (data) => {
        let {dataTable, dataRollBackTable} = this.state;
        data.forEach(item => {
            const existingItemIndex = dataTable.findIndex(dataTableItem => dataTableItem.kodeVariant === item.kodeVariant);
            if (existingItemIndex !== -1) {
                dataTable[existingItemIndex] = {
                    ...dataTable[existingItemIndex],
                    bbnPrice: item.bbnPrice + dataTable[existingItemIndex].bbnPrice,
                    differenceIncomeBbn: item.differenceIncomeBbn + dataTable[existingItemIndex].differenceIncomeBbn
                };
                dataRollBackTable[existingItemIndex] = {
                    ...dataRollBackTable[existingItemIndex],
                    bbnPrice: item.bbnPrice + dataRollBackTable[existingItemIndex].bbnPrice,
                    differenceIncomeBbn: item.differenceIncomeBbn + dataRollBackTable[existingItemIndex].differenceIncomeBbn
                }
            } else {
                let variant = this.state.dataVariant.find(variantItem => variantItem.value === item.kodeVariant);
                let savedObj = {
                    kodeVariant: {
                        label: `${variant?.value} - ${variant?.kodeUnitPabrik} - ${variant?.name}`,
                        value: variant?.value,
                        kodeUnitPabrik: variant?.kodeUnitPabrik
                    },
                    kodeUnitPabrik: variant?.kodeUnitPabrik,
                    namaVariant: variant?.name,
                    bbnPrice: item.bbnPrice,
                    differenceIncomeBbn: item.differenceIncomeBbn
                };

                dataTable = [...dataTable, savedObj];
                dataRollBackTable = [...dataRollBackTable, savedObj]
            }
        });

        this.setState((prevState) => ({
            ...prevState,
            dataTable: dataTable,
            dataRollBackTable: dataRollBackTable
        }))

        this.handleUploadFileModalVisibility();
    }

    handlePrint = () => {
        this.setState((prevState) => ({
            ...prevState,
            printModalVisible: !prevState.printModalVisible
        }));
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchDataSamsat = async (body) => {
        const { dataCabang } = this.props;
        const listCabang = dataCabang?.map(item => item.value) || [];

        try {
            const response = await Api
                .create("NAGAMAS_MASTER_DATA")
                .getAllMasterSamsat(
                    body && Object.keys(body).length > 0
                        ? body
                        : { listCabang }
                );

            if (response?.ok && !R.isEmpty(response?.data)) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataSamsat: [
                        { value: "ALL", label: "ALL" },
                        ...response.data.data.map((item) => ({
                            value: item.samsatId,
                            label: item.samsatName,
                        })),
                    ],
                }));
            }
        } catch (error) {
            console.error("error: ", error);
        }
    };

    
    removeDuplicateByValue(arr) {
      return Array.from(new Map(arr.map(item => [item.value, item])).values());
    }

    fetchDataVariant = async () => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllVariant();
            if (response.ok) {
                const allVariant = response.data.data || [];
                const dataVariant = allVariant.map(item => ({
                    label: `${item.kodeVariant} - ${item.kodeUnitPabrik} - ${item.namaVariant}`, 
                    value: item.kodeVariant, 
                    name: item.namaVariant, 
                    kodeUnitPabrik: item.kodeUnitPabrik
                }));

                const dataKodeUnitPabrik = this.removeDuplicateByValue(allVariant.map(item => ({
                    label: item.kodeUnitPabrik, 
                    value: item.kodeUnitPabrik
                })) || []);

                this.setState((prevValue) => ({
                    ...prevValue,
                    dataVariant: dataVariant,
                    dataVariantRollBack: dataVariant,
                    dataKodeUnitPabrik: dataKodeUnitPabrik,
                    dataKodeUnitPabrikRollBack: dataKodeUnitPabrik
                }));
            }
        } catch (error) {
            console.log("error: ", error);
        }
    }

    fetchDataDetail = async () => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getDetailMasterBBN(this.props.selectedData?.id);
            if (response.ok) {
                let dataDetail = response.data.data.variant.map(item => {
                    const varDTO = item.variantAndTypeDTO;
                    return {
                        bbnPrice: item.bbnPrice,
                        differenceIncomeBbn: item.differenceIncomeBbn,
                        kodeVariant: {
                            label : `${varDTO.kodeVariant} - ${varDTO?.kodeUnitPabrik} - ${varDTO.namaVariant}`,
                            value : item.variantAndTypeDTO?.kodeVariant,
                        },
                        namaVariant: item.variantAndTypeDTO?.namaVariant,
                        kodeUnitPabrik: item.variantAndTypeDTO?.kodeUnitPabrik
                    }
                });
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataTable: dataDetail,
                    dataRollBackTable: dataDetail,
                    pagination: {
                    ...prevValue.pagination,
                    totalData: response.data.data.length,
                }
                }));

                this.props.setValue("bbnName", response.data.data.bbnName);
                this.props.setValue("startDate", response.data.data.startDate);
                this.props.setValue("endDate", response.data.data.endDate);
                this.props.setValue("kodeSamsat", response.data.data.samsat.map(item => mapToDDL(item.samsatName, item.samsatId)));
                this.props.setValue("variants", dataDetail);
            }
        } catch (error) {
            console.log("error: ", error);
        }
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        const {pagination} = this.state;
        return (
            <Fragment>
                <SimpleModal
                    title="Tambah Tabel BBN"
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose()}
                    content={
                        <ModalContainer>
                            <div className="grid grid-2x gap-20px grid-mobile-none">
                                <div id="grid-1">
                                    <SimpleInput
                                        id="input_text_table_name_bbn"
                                        name="bbnName"
                                        label="Nama Tabel BBN"
                                        mandatory
                                        errorMessage={this.props.errors.bbnName}
                                        value={this.props.controls.bbnName.value}
                                        readOnly={this.props.deleteAction}
                                        onChange={({target}) =>
                                            this.props.setValue(target.name, target.value)
                                        }
                                    />
                                    <SimpleDDL
                                        id="select_options_samsat"
                                        name="kodeSamsat"
                                        label="SAMSAT Berlaku"
                                        box="multiselect"
                                        mandatory
                                        errorMessage={this.props.errors.kodeSamsat}
                                        readOnly={this.props.deleteAction}
                                        options={this.state.dataSamsat}
                                        value={this.props.controls.kodeSamsat.value}
                                        onChange={(value, {name}) =>
                                            this.props.setValue(name, value)
                                        }
                                    />
                                </div>
                                <div id="grid-2">
                                    <FlexView column>
                                        <SimpleDate
                                            label="Tanggal Awal"
                                            mandatory
                                            errorMessage={this.props.errors.startDate}
                                            disabled={this.props.deleteAction}
                                            date={this.props.controls.startDate.value}
                                            onChange={(value) =>
                                                this.props.setValue("startDate", M(value).format("DD-MM-YYYY"))
                                            }
                                        />
                                    </FlexView>
                                    <FlexView column>
                                        <SimpleDate
                                            label="Tanggal Akhir"
                                            mandatory
                                            errorMessage={this.props.errors.endDate}
                                            disabled={this.props.deleteAction}
                                            date={this.props.controls.endDate.value}
                                            onChange={(value) =>
                                                this.props.setValue("endDate", M(value).format("DD-MM-YYYY"))
                                            }
                                        />
                                    </FlexView>
                                </div>
                            </div>

                            <FlexView vAlignContent="center" hAlignContent="right" className="margin-bottom-20px margin-top-20px">
                                <SimpleInput
                                    type="text"
                                    name="kodeVariant"
                                    placeholder="Kode Varian"
                                    containerclassname="margin-bottom-none"
                                    value={this.state.search.kodeVariant}
                                    onChange={(e) => this.handleValueChangeSearch(e.target.name, e.target.value)}
                                />
                                <SimpleButton
                                    text="Cari"
                                    onClick={this.handleSubmitSearch}
                                    className="margin-top-5px"
                                />
                                <SimpleButton
                                    text="Reset"
                                    onClick={this.handleResetSearch}
                                    className="margin-top-5px"
                                />
                            </FlexView>

                            <SimpleDataTable
                                key={`${pagination.totalData}-${pagination.page}`}
                                data={this.state.dataTable}
                                columns={this.state.tableColumns}
                                toCount={pagination.totalData}
                                rowsPerPage={pagination.limit}
                                page={pagination.page - 1}
                                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                            />

                            <div style={{textAlign: "right", marginTop: "20px"}}>
                                {
                                    this.props.deleteAction
                                        ?
                                        <>
                                            <SimpleButton
                                                type="button"
                                                text="Hapus"
                                                onClick={() => this.handleDeleteModalVisibility()}
                                            />
                                        </>
                                        :
                                        <>
                                            <SimpleButton
                                                type="button"
                                                text="Upload"
                                                onClick={() => this.handleUploadFileModalVisibility()}
                                            />
                                            <SimpleButton
                                                type="button"
                                                text="Tambah"
                                                onClick={() => this.handleAddRow()}
                                            />
                                            <SimpleButton
                                                type="button"
                                                text="Cetak"
                                                onClick={() => this.handlePrint()}
                                            />
                                            <SimpleButton
                                                type="button"
                                                text="Simpan"
                                                onClick={() => this.handleSubmit()}
                                            />
                                        </>
                                }

                            </div>
                        </ModalContainer>
                    }
                />

                {this.state.uploadFileModalVisible && (
                    <MasterBBNUploadFile
                        visible={this.state.uploadFileModalVisible}
                        onChange={this.handleChangeFile}
                        onClickClose={() => this.handleUploadFileModalVisibility()}
                    />
                )}

                {this.state.printModalVisible && (
                    <SimplePrintTable onClearPrint={this.handlePrint}/>
                )}

                {this.state.deleteModalVisible && (
                    <AlertModal
                        warningMessage={this.state.deleteMessage}
                        modalVisible={this.state.deleteModalVisible}
                        onSubmit={() => this.props.onDelete(this.props.selectedData?.id)}
                        onClickClose={() => this.handleDeleteModalVisibility()}
                    />
                )}

                {this.state.deleteRawModalVisible && (
                    <AlertModal
                        warningMessage={this.state.deleteRawMessage}
                        modalVisible={this.state.deleteRawModalVisible}
                        onSubmit={() => this.handleDeleteRow(this.state.selectedDataDetailIndex)}
                        onClickClose={() => this.handleDeleteRawModalVisibility()}
                    />
                )}

                {this.state.warningModalVisible && (
                    <SimpleAlert
                        title={"Information"}
                        content={
                            <div>
                                <p>
                                    {this.state.warningMessage}
                                    <br/>
                                    Mohon periksa kembali.
                                </p>
                            </div>
                        }
                        visible={this.state.warningModalVisible}
                        onClickClose={this.handleWarningModalVisibility}
                        additionalButtons={
                            <SimpleButton
                                type="button"
                                text="OK"
                                onClick={() => this.handleWarningModalVisibility()}
                            />
                        }
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading}/>
            </Fragment>
        );
    }
}

export default withFormGroup(MasterBBNModifying);

class AlertModal extends Component {
    render() {
        return (
            <SimpleAlert
                title={"Question"}
                content={
                    <div>
                        <p>
                            {this.props.warningMessage}
                        </p>
                    </div>
                }
                additionalButtons={
                    <Fragment>
                        <FlexView>
                            <SimpleButton
                                text="Batal"
                                secondary
                                onClick={this.props.onClickClose}
                            />
                            <SimpleButton
                                text="Iya"
                                onClick={this.props.onSubmit}
                            />
                        </FlexView>
                    </Fragment>
                }
                visible={this.props.modalVisible}
                onClickClose={this.props.onClickClose}
            />
        )
    }
}